import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import {
  useGqlMutation,
  useSuspenseGqlQuery,
} from "@/lib/GraphQLCodegen/fetcher";
import { invoiceRecordQuery } from "@/app/Invoices/GraphQL/invoiceRecordQuery";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { SwitchInput } from "@/lib/Components/Form/Inputs/SwitchInput";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import {
  ArchiveBoxXMarkIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";
import { voidInvoiceMutation } from "@/app/Invoices/GraphQL/invoiceMutations";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";

export function VoidInvoiceDialog({ invoiceId }: { invoiceId: string }) {
  useSuspenseGqlQuery(invoiceRecordQuery, {
    id: invoiceId,
  });
  const { mutateAsync } = useGqlMutation(voidInvoiceMutation);
  const { close } = useDialogState();

  return (
    <BaseDialog
      title={
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:h-10 sm:w-10">
            <ExclamationTriangleIcon
              className="h-6 w-6 text-red-600"
              aria-hidden="true"
            />
          </div>
          <div>Void Invoice</div>
        </div>
      }
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-600">
          Are you sure you want to void this invoice? This action cannot be
          undone.
        </p>

        <GenericForm
          initialValues={{ void_payments: false }}
          onSubmit={async (values) => {
            await mutateAsync({
              id: invoiceId,
              voidPayments: values.void_payments,
            });

            return close();
          }}
        >
          <div className="col-span-full rounded-lg border border-gray-200 bg-gray-50 p-4">
            <SwitchInput
              name="void_payments"
              label="Void associated payments"
              description="When enabled, payments will be voided and cannot be collected. When disabled, unpaid payments will roll over to the next invoice."
            />
          </div>

          <DialogSubmitButton
            text="Void Invoice"
            color="red"
            Icon={ArchiveBoxXMarkIcon}
          />
        </GenericForm>
      </div>
    </BaseDialog>
  );
}
